import { Injectable } from "@angular/core";
import { ofType } from "@ngrx/effects";
import { ActionsSubject, select, Store } from "@ngrx/store";
import {
  IAMAccountCreateCmd,
  IAMAccountCredentialsDownloadCmd,
  IAMAccountCredentialsUpdateCmd,
  IAMAccountDeleteCmd,
  IAMAccountUpdateCmd
} from "@youm-front/iam-account/domain";
import { IAMAccountsActions } from "../actions";
import { IAMAccountsSelectors } from "../selectors";
import { map } from "rxjs/operators";

@Injectable()
export class IAMAccountsFacade {
  iamAccountCreateSuccess$ = this.actionsSubject.pipe(
    ofType(IAMAccountsActions.iamAccountCreateSuccess),
    map(() => {
      return;
    })
  );
  iamAccountUpdateSuccess$ = this.actionsSubject.pipe(
    ofType(IAMAccountsActions.iamAccountUpdateSuccess),
    map((_) => _.account)
  );
  isLoading$ = this.store.pipe(select(IAMAccountsSelectors.isLoading));
  iamAccounts$ = this.store.pipe(select(IAMAccountsSelectors.iamAccounts));

  constructor(
    private readonly actionsSubject: ActionsSubject,
    private readonly store: Store
  ) {}

  iamAccountCreate(iamAccountCreateCmd: IAMAccountCreateCmd) {
    this.store.dispatch(
      IAMAccountsActions.iamAccountCreate({
        iamAccountCreateCmd
      })
    );
  }

  iamAccountCredentialsDownload(
    iamAccountCredentialsDownloadCmd: IAMAccountCredentialsDownloadCmd
  ) {
    this.store.dispatch(
      IAMAccountsActions.iamAccountCredentialsDownload({
        iamAccountCredentialsDownloadCmd
      })
    );
  }

  iamAccountCredentialsUpdate(
    iamAccountCredentialsUpdateCmd: IAMAccountCredentialsUpdateCmd
  ) {
    this.store.dispatch(
      IAMAccountsActions.iamAccountCredentialsUpdate({
        iamAccountCredentialsUpdateCmd
      })
    );
  }

  iamAccountDelete(iamAccountDeleteCmd: IAMAccountDeleteCmd) {
    this.store.dispatch(
      IAMAccountsActions.iamAccountDelete({
        iamAccountDeleteCmd
      })
    );
  }

  iamAccountsList() {
    this.store.dispatch(IAMAccountsActions.iamAccountsList());
  }

  iamAccountUpdate(iamAccountUpdateCmd: IAMAccountUpdateCmd) {
    this.store.dispatch(
      IAMAccountsActions.iamAccountUpdate({
        iamAccountUpdateCmd
      })
    );
  }
}
